// @flow

import React, {Component} from 'react'
import {withRouter} from 'react-router'
import {observer} from 'mobx-react'
import {isEmpty} from 'lodash'

import api from '../../../src/api/client'
import AdminHeader from './AdminHeader'
import store from '../store'
import MedicineManagement from './MedicineManagement'
import Login from './Login'
import Footer from '../../common/components/Footer'

import css from './AdminPage.css'

type State =  {
  isLoggedIn: boolean,
}

@observer
class AdminPage extends Component {
  state: State = {
    isLoggedIn: false,
  }

  authenticateToken = async() => {
    let token = localStorage.getItem('token')
    if (token) {
      try {
        const response = await api.resources.authentication.authenticate()
        if(response.status === 200) {
          this.setState({isLoggedIn: true})
        }

      } catch (e) {
        console.log(e)
      }
    }
  }

  getFooterLabels = async () => {
    // Fetch footer label data only if empty
    if (isEmpty(store.footerLabels)) {
      const footerLabels = await api.resources.footer.getFooterLabels()
      if (!isEmpty(footerLabels)) {
        const footerLabelObj = {
          company: footerLabels.footer_company,
          description: footerLabels.footer_description,
          phone: footerLabels.footer_phone,
          copyright: footerLabels.footer_copyright,
          queueInfo: footerLabels.footer_queueInfo,
        }
        store.saveFooterLabels(footerLabelObj)
        store.saveSavedFooterLabels(footerLabelObj)
      }
    }
  }

  componentWillMount() {
    this.authenticateToken()
    this.getFooterLabels()
  }

  logout = () => {
    this.setState({isLoggedIn: false})
    localStorage.setItem('token', '')
    localStorage.setItem('expires', '')
  }

  render() {
    const footerLabels: Object = store.savedFooterLabels
    const {company, description, phone, copyright, queueInfo} = footerLabels
    const {isLoggedIn} = this.state

    return (
      <div className={css.component}>
        <AdminHeader showLogout={isLoggedIn} onLogout={() => this.logout()}/>
        {!isLoggedIn && <Login onLogin={() => this.setState({isLoggedIn: true})}/>}
        {isLoggedIn && <MedicineManagement show={isLoggedIn} onUnauthorized={() => this.logout()}/>}
        <Footer
          company={company}
          description={description}
          phone={phone}
          copyright={copyright}
          queueInfo={queueInfo}/>
      </div>
    )
  }
}

export default withRouter(AdminPage)



// WEBPACK FOOTER //
// ./src/admin/components/AdminPage.js